import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../../interfaces/response";

interface IRelationshipManager {
  id: number;
  firstName: string;
  lastName: string;
}

export const fetchRelationshipManagers = async (): Promise<
  IResponse<IRelationshipManager[]>
> => {
  const { data } = await getData(
    ajaxEndpoints.GET_WEALTH_MANAGEMENT_RELATIONSHIP_MANAGERS,
  );
  return data;
};

const useRelationshipManagers = () => {
  return useQuery<IResponse<IRelationshipManager[]>>(
    ["relationshipManagers"],
    fetchRelationshipManagers,
    {
      refetchOnWindowFocus: false,
    },
  );
};

export default useRelationshipManagers;
